import EfHighlights from '@elem/ui/ef-highlights';
import { useRouter } from 'next/router';
import CompA from '../ListA/CompA';
import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import styles from './index.module.scss';
import ItemA from './ItemA';
import ItemB from './ItemB';
import ItemC from './ItemC';
import ItemD from './ItemD';
import ItemE from './ItemE';
import ItemF from './ItemF';
import ItemG from './ItemG';
import ItemH from './ItemH';

export default function TheComp() {
    const { locale = 'us' } = useRouter();
    const { pageStatus } = useProductStore();
    const listA = [
        {
            children: <ItemA />,
        },
        {
            children: <ItemB />,
        },
        {
            children: <ItemC />,
        },
        {
            children: <ItemD />,
        },
        {
            children: <ItemE />,
        },
        {
            children: <ItemF />,
        },
        {
            children: <ItemG />,
        },
        {
            children: <ItemH />,
        },
    ];
    return (
        <div className={styles.TheComp}>
            {['au'].includes(locale) && pageStatus === IPageStatus.statusA && <CompA />}
            <EfHighlights items={listA} />
        </div>
    );
}
